"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.is-array.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-string.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = runInView;
require("core-js/modules/es.object.assign.js");
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var DEFAULTS = {
  threshold: [0, 1],
  percent: 0,
  count: 1
};

/**
 * Calls a function once when an element first enters the viewport.
 * @param  {HTMLElement}   element The element to observe
 * @param  {Function}      fn      The function to be called
 * @param  {Number}        count   The maximum number of times fn can be called.
 * @return {IntersectionObserver}
 */

function runInView(element) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  var options = arguments.length > 2 ? arguments[2] : undefined;
  if (!window.IntersectionObserver) {
    return requestAnimationFrame(fn({
      target: element
    }));
  }
  var thisOptions = Object.assign(DEFAULTS, options);
  var i = 0;
  var observer = new window.IntersectionObserver(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      entry = _ref2[0];
    if (meetsThreshold(entry, thisOptions)) {
      fn(entry);
      i += 1;
      if (i <= thisOptions.count) {
        observer.unobserve(entry.target);
      }
    }
  }, {
    threshold: thisOptions.threshold
  });
  observer.observe(element);
  return observer;
}
function meetsThreshold(_ref3, options) {
  var intersectionRatio = _ref3.intersectionRatio,
    isIntersecting = _ref3.isIntersecting;
  // Under rare conditions,
  // `intersectionRatio === 0` while `isIntersecting === true`.
  // The following conditional allows `fn` to execute in that scenario.
  if (options.percent === 0) {
    return isIntersecting;
  }
  return intersectionRatio > options.percent;
}
//# sourceMappingURL=runInView.js.map